import { render } from "./NotificationWindow.vue?vue&type=template&id=2d76d53c&scoped=true"
import script from "./NotificationWindow.vue?vue&type=script&lang=js"
export * from "./NotificationWindow.vue?vue&type=script&lang=js"

import "./NotificationWindow.vue?vue&type=style&index=0&id=2d76d53c&lang=scss"
import "./NotificationWindow.vue?vue&type=style&index=1&id=2d76d53c&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d76d53c"]])

export default __exports__